import { ca } from '@cian/analytics';

import { cookieHelper } from '../../utils/cookieHelper';

export function trackingIncomingMessage(chatId: string) {
  if (cookieHelper('trackIncommingMessage')) {
    ca('eventSite', {
      action: 'get_message',
      category: 'Chat',
      label: chatId,
      name: 'oldevent',
    });
  }
}
